import React from 'react';
import {Garlic, ShoppingCart, starFill} from "../../../assets/images/images";
import {APP_DOMAIN_PREFIX} from '../../../environment';
import './style.scss'

function Index(props) {

  const {order,item,history} = props;
    const onSellerItemClick = () => {
      if(item.harvestId.qtyName)
      item.harvestId.measure = item.harvestId.qtyName
      if(item.harvestName)
      item.harvestId.harvest = item.harvestName
    history?.push({
      pathname: "/detail",
      state: { product: item.harvestId },
    });
  };
    let position = item?.harvestId?.imagePath?.search("userImages");
  let imageUrl = APP_DOMAIN_PREFIX + item?.harvestId?.imagePath;
  if(position == -1)
   imageUrl = APP_DOMAIN_PREFIX + "/userImages/" + item?.harvestId?.imagePath;

  return (<div className='summary-card mb-10'>
      <div className='first-section display-flex '>
        <div className='img-section'>
          <img src={imageUrl} alt=''/>
        </div>
        <div className='text-section'>
          <p className='discount-color font-12 m-0'>{item?.harvestId?.sectorId?.sectorCategory}</p>
          <h2 className='text-capitalize'>{item?.harvestName}</h2>
          <p className='font-12 in-active-color'>{item?.harvestId?.productDesciption}.</p>
          <div className='display-flex align-items-center mt-20'>
            {/* <div>
              <img src={starFill} alt={''} width={20}/>
              <img src={starFill} alt={''} width={20}/>
              <img src={starFill} alt={''} width={20}/>
              <img src={starFill} alt={''} width={20}/>
            </div> */}
            {/* <p className='font-18 text-bold '>4.0</p>
            <p className='font-12 in-active-color  mt-0'> 235 Reviews</p> */}
          </div>
        </div>
      </div>

      <div className='btn-section'>
        <div className='display-flex'>
          {order ?( <button className='buy-btn  text-bold'>Status</button>):(<>
            {/* <button className='buy-btn  text-bold'>see details</button> */}
            <button onClick={onSellerItemClick} className='buy-btn1  text-bold ml-10'>see details</button>
          </>)}
        </div>
        <div className='display-flex  align-items-center  mt-20'>
          <p className='font-18 text-bold text-bold'>PKR {item.unitPrice}</p>
          <p className='in-active-color font-12 ml-20'>Quantity {item.productQty}</p>
        </div>
        {order ? <button className=' add-cart-btn-small support-btn-small'>Contact Support </button> :
          <button onClick={props.deleteCart} className='  add-cart-btn-small'>
            <ShoppingCart/>
            <span className='ml-10'>Remove</span>
          </button>}
      </div>
    </div>
  );
}

export default Index;
